import { MailTypeIds } from 'src/app/core/constants/mail-box-const';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-move-mails-list',
  templateUrl: './move-mails-list.component.html',
  styleUrls: ['./move-mails-list.component.scss']
})
export class MoveMailsListComponent {
  @Input() mailRuleList: any;
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteRule: EventEmitter<any> = new EventEmitter();

  // mainTypes: MailTypeIds;

  displayedColumns: string[] = [
    'fromMail',
    'fromName',
    'subject',
    // 'receiptMailId',
    'moveToMail',
    'fromDate',
    'toDate',
    'action'
  ];

  editRule(element) {
    this.onEdit.emit(element)
  }
  deleteRule(element) {
    this.onDeleteRule.emit(element)
  }
}
